module.exports = require("ci-info");